export enum DiscountCouponActionTypes {
    API_RESPONSE_SUCCESS = '@@discountCoupon/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@discountCoupon/API_RESPONSE_ERROR',

    ADD_DISCOUNT_COUPON = '@@discountCoupon/ADD_DISCOUNT_COUPON',
    EDIT_DISCOUNT_COUPON = '@@discountCoupon/EDIT_DISCOUNT_COUPON',
    GET_DISCOUNT_COUPONS = '@@discountCoupon/GET_DISCOUNT_COUPONS',
    GET_DISCOUNT_COUPON = '@@discountCoupon/GET_DISCOUNT_COUPON',
    RESET = '@@discountCoupon/RESET',
    RESET_SUCCESS = '@@discountCoupon/RESET_SUCCESS',
    RESET_ERROR = '@@discountCoupon/RESET_ERROR',
}
